module.exports = __webpack_public_path__ + "static/media/Gill_Verso_System_Web_Banner.5dc24b2a.jpg";